import React from "react";
import _ from "lodash";
import { connect } from 'react-redux'

import {Grid, withStyles} from "@material-ui/core";

import {ModelPortfolioBase} from "../../../../../../../../Modelportfolios/Create/ModelportfolioBase";
import Link from "../../../../../../../../../components/Link";
import {ModelportfoliosFilters} from "../../../../../../../../Modelportfolios";

import {
  newDesignTableStructureMP,
  newDesignTableStructureVL,
  newDesignTableStructureWithSavingsPlan,
  newDesignTableStructureWithEinzeltitel
} from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/Portfolio/table-data";

import {
  calculateInstrumentsAverageSRRI,
  CustodianAndRiskProfileInstrumentsHandler, getBankData, getContractTypeConfiguration,
  nextAvailableFromDate,
  splitEinzeltitelTradingInstruments
} from '../../../../../../../utils'
import { instrCustodianData } from '../../../../../../../../Trades/utils';
import {SERVICE_CONCEPTS} from "../../../../../../../../Trades/constants";
import RiskScoreConfirmationModal from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/RiskScoreConfirmationModal/RiskScoreConfimrationModal";
import {RiskScoreConfirmationModalContext} from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/InvestmentRecommendationStep";
import {
  calculateTotalAmount
} from "../../../../../../../../Trades/components/TradeStep/components/PortfolioTrade/table-data";
import useInternalTableStyles from './components/InternalTable/styles'
import DashboardTable from "../../../../../../../../../components/DashboardTable/DashboardTable";
import {USE_CUSTODIAN_ONLINE_PORTAL_INFO_TEXT} from "../../../../../../../../Trades/components/TradeStep/components/PortfolioTrade/utils";

import {toGermanFormat} from "../../../../../../../../../utils/numberFormater";
import WarningTooltip from "../../../../../../../../../components/WarningTooltip";
import BaseDialog from "../../../../../../../../../components/BaseDialog/BaseDialog";
import {favoriteListDetailsTableStructure} from "../../../../../../../../Modelportfolios/components/InstrumentsList/table-data";
import InvestmentStrategySelection from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/InvestmentStrategySelection/InvestmentStrategySelection";
import ModelPortfolioSelection
  from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/ModelPortfolioSelection/ModelPortfolioSelection";
import PrimaryButton from "../../../../../../../../../components/Buttons/PrimaryButton";
import useAssetSelectionSearch from "../../hooks/useFilters";
import {getAssetInternalId} from "../../../../../../../../CustomerDashboard/utils";
import {AVG_PTF_INFO, INSTRUMENT_SOURCE_TYPE} from "../../../../../../../constants";
import PortfolioBuilder
  from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/PortfolioBuilder";
import GoogleAnalytics from "../../../../../../../../../utils/GoogleAnalytics";
import MusterDepot
  from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/MusterDepot/MusterDepot";
import FavoriteListSelection
  from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/FavoriteListSelection/FavoriteListSelection";
import {
  MUSTERDEPOT_ALL_ASSETS_AVAILABLE,
  MUSTERDEPOT_NOT_ALL_ASSETS_AVAILABLE
} from "../../../ProductsSelectionSteps/components/InvestmentRecommendationStep/components/MusterDepot/constants";
import {
  displaySuccessSnackBar,
  displayWarningSnackBar
} from "../../../../../../../../../components/SnackbarProvider/actions";
import {ERROR_BACKGROUND} from "../../../../../../../../../themes/themeConfigurator";
import InfoCard from "../../../DynamicStep/components/InfoCard";
import PortfolioBuilderButton
  from "../../../../../../../../CustomerDashboardV2/components_v2/ActionButtons/PortfolioBuilderButton";
import EmptyTableMessage from "../../../../../../EmptyTableMessage";

import styles from "./styles";
import AssetsSelectionPage from "./components/AssetsSelectionPage";
import useCancelSelection from "./hooks/useCancelSelection";
import {
  getValidityDateOptions,
  initEinzeltitelSettings,
  NO_ORDER_TYPE_OPTION
} from "../../../../../../../einzeltitel_helper";


const TotalPortfolioAmount = (instruments) => {
  let savingsPlanAmount = 0, acceptedAmount = 0;
  (instruments || []).forEach(i => {
    savingsPlanAmount += i.savingsPlanAmount;
    acceptedAmount += i.amount || i.transaction_value || 0;
  });
  acceptedAmount = _.round(acceptedAmount, 2);
  savingsPlanAmount = _.round(savingsPlanAmount, 2);

  return {acceptedAmount, savingsPlanAmount};
};

const getAverageSrriValue = (instruments) => calculateInstrumentsAverageSRRI(
  instruments, (instrument) => (instrument.amount || 0));

const initSourceAssets = (instrumentsSource, assets) => {
  return assets.map((asset) => {
    if(+asset.weight){
      const singleBuyAmount = instrumentsSource.amount || 0;
      const savingsPlanAmount = instrumentsSource.savingsPlanAmount || 0;

      asset.weight = +asset.weight;
      asset.amount = singleBuyAmount * (asset.weight / 100);
      asset.savingsPlanAmount = savingsPlanAmount * (asset.weight / 100);
    }

    return asset;
  })
};

const validityDateOptions = getValidityDateOptions();

const EinzeltitlelTable = (props) => {
  const internalTableClasses = useInternalTableStyles();

  const {
    handleInstrumentChange,
    handleInstrumentsChange,
    internalInstruments,
    emptyTableMsg,
    bankCompanyId,
    readOnly,
    clientSRRI,
    error,
    stockExchangeOptions,
    orderTypeOptions,
    handleRemove,
    isOpenOnly,
    onAddAssetClick,
  } = props;

  const handleOrderSettingChange = (item, value, populate) => {
    const items = populate ? internalInstruments : [item];
    handleInstrumentsChange(items, value)
  };

  const handleLimitValueChange = (item, value, amount) => {
    handleInstrumentChange(item, {
      limit: value,
      transaction_value: amount, amount, errors: {
        ...item.errors,
        limit: null
      }});
  };

  const orderVariations = React.useMemo(() => {
    return [NO_ORDER_TYPE_OPTION, ...(orderTypeOptions || [])];
  }, [orderTypeOptions]);

  const handleQuantityChange = (item, value) => {
    let quantity = value;
    if (_.get(item, 'data.quantity')) {
      quantity = value <= item.data.quantity ? value : item.data.quantity
    }
    const amount = calculateTotalAmount(item, item.limit, quantity);
    handleInstrumentChange(item, {quantity: quantity, transaction_value: amount, amount, errors: {...item.errors, quantity: null}});
  };

  return (
    <DashboardTable
      structure={newDesignTableStructureWithEinzeltitel}
      dataSource={internalInstruments || []}
      expanded={true}
      loadingIndicator={false}
      tableClasses={internalTableClasses}
      withFooter={true}
      withInputs={true}
      emptyDataMessage={emptyTableMsg}
      dataSourceKeyField={'isin'}
      options={{
        bankCompanyId: bankCompanyId,
        clientSRRI: clientSRRI,
        readOnly: readOnly,
        error: error,
        action: 'buy',
        stockExchangeOptions: stockExchangeOptions,
        orderTypeOptions: orderVariations,
        validityDateOptions: validityDateOptions,
        onChange: handleOrderSettingChange,
        handleLimitValueChange: handleLimitValueChange,
        handleQuantityChange: handleQuantityChange,
        onRemoveAssetClick: handleRemove,
        acceptedAmount: TotalPortfolioAmount(internalInstruments).acceptedAmount,
        isOpenOnly: isOpenOnly,
        hideAcceptanceCriteriasUnderName: true,
        isNewDesign: true,
        onAddAssetClick: onAddAssetClick,
        hasMultipleShares: (internalInstruments || []).length > 1
      }}
    />
  )
};

const MpPiSelectionModalStyles = () => ({
  dialogContent: {
    paddingLeft: 0,
    paddingRight: 0,
    display: 'flex',
  }
});

const MpPiSelectionModal = withStyles(MpPiSelectionModalStyles)((props) => {
  const {
    classes,
    open,
    handleClose,
    instrumentsHandler,
    dataService,
    isMPProcess,
    depot,
    handleSaveClick,
  } = props;

  const [activeSourceItem, setActiveSourceItem] = React.useState(null);
  const Component = isMPProcess ? ModelPortfolioSelection : InvestmentStrategySelection;

  const confirmSelection = (item) => {
    // TODO: we should rename field on backend
    handleSaveClick({...item, sri: item.srri}, initSourceAssets(item, item.assets));
    handleClose();
    cleanSourceItem();
  };

  const handleNextClick = () => {
    confirmSelection(activeSourceItem);
  };

  const cleanSourceItem = () => {
    setActiveSourceItem(null);
  };

  const handleBackClick = () => {
    if (activeSourceItem) {
      cleanSourceItem();
    } else {
      handleClose();
    }
  };

    /**
   * Handler for onDetailsClick event.
   * @param item Selected item
   * @param skipDetails Flag, that indicate if Item Details screen should be shown
   */
  const handleDetailsClick = (item, skipDetails) => {
    if (skipDetails) {
      confirmSelection(item)
    } else {
      setActiveSourceItem(item);
    }
  };

  return (
    <BaseDialog
      open={open}
      title={isMPProcess ? 'Modellportfolio auswählen' : 'Vermögensverwaltung auswählen'}
      handleClose={handleClose}
      customClasses={classes}
      actions={
        <Grid container spacing={2} justify={"flex-end"}>
          <Grid item>
            <PrimaryButton
              variant={'outlined'}
              text={!activeSourceItem ? 'Abbrechen' : 'Zurück'}
              onButtonClick={handleBackClick}
            />
          </Grid>
          {!!activeSourceItem && (
            <Grid item>
              <PrimaryButton
                text={'Hinzufügen & zurück zur Produktauswahl'}
                onButtonClick={handleNextClick}
              />
            </Grid>
          )}
        </Grid>
      }
    >
      <Component
        depot={depot}
        dataService={dataService}
        onDetailsClick={handleDetailsClick}
        instrumentsHandler={instrumentsHandler}
        selectedItem={activeSourceItem}
        selectedInstruments={activeSourceItem && activeSourceItem.assets}
        forceAllAssetsSelection={false}
        hideTitle
      />
    </BaseDialog>
  )
});

const AssetsSelectionSourceComponent = withStyles(MpPiSelectionModalStyles)((props) => {

  const [selectedInstruments, setSelectedInstruments] = React.useState([]);

  const handleDetailsClick = (item, skipDetails, hasWarning) => {
    if (skipDetails) {
      if(props.activeSource === 'MusterDepot'){
        const msg = hasWarning ? MUSTERDEPOT_NOT_ALL_ASSETS_AVAILABLE : MUSTERDEPOT_ALL_ASSETS_AVAILABLE;
        const displaySnackBar = hasWarning ? displayWarningSnackBar : displaySuccessSnackBar;
        props.dispatch(displaySnackBar(msg))
      }
      props.handleAddInstruments(item.assets)
    } else {
      props.setActiveSourceItem(item);
    }
  };

  const handleSave = () => {
    props.handleAddInstruments(selectedInstruments);
  };

  const onInstrumentSelect = (asset) => {

    let selectedAssetsCopy = [...selectedInstruments];

    const idx = _.findIndex(selectedAssetsCopy, a => getAssetInternalId(a) === getAssetInternalId(asset));
    if (idx !== -1) {
      selectedAssetsCopy.splice(idx, 1);
    } else {
      selectedAssetsCopy = [...selectedAssetsCopy, asset]
    }

    setSelectedInstruments(selectedAssetsCopy);
  };


  const [Component, title] = {
    "MusterDepot": [MusterDepot, "Musterdepot auswählen"],
    "FavouriteList": [FavoriteListSelection, "Favoritenlisten"]
  }[props.activeSource];

  if(!Component) return null;

  return (
    <BaseDialog
      open
      title={title}
      handleClose={props.handleBackClick}
      disableBackdropClick
      customClasses={props.classes}
      actions={
        <Grid container spacing={2} justify={"flex-end"}>
          <Grid item>
            <PrimaryButton variant={'outlined'} text={'Zurück'} onButtonClick={props.handleBackClick} />
          </Grid>
          {!!props.activeSourceItem && (
            <Grid item>
              <PrimaryButton
                text={'Speichern & weiter'}
                onButtonClick={handleSave}
                disabled={_.isEmpty(selectedInstruments)}
              />
            </Grid>
          )}
        </Grid>
      }
    >
      <Component
        dataService={props.dataService}
        onDetailsClick={handleDetailsClick}
        instrumentsHandler={props.instrumentsHandler}
        onInstrumentSelect={onInstrumentSelect}
        onSelectAll={setSelectedInstruments}
        selectedItem={props.activeSourceItem}
        selectedInstruments={selectedInstruments}
        hideTitle
      />
    </BaseDialog>
  )
});

const AssetsSelectionModalStyles = (theme) => ({
  rootInvisible: {
    opacity: 0
  },
  header: {
    fontSize: 15,
    fontFamily: 'Roboto-Bold'
  },
  tableCell: {
    width: 75,
    '&:first-child': {
      width: 350,
      [theme.breakpoints.down('lg')]: {
        width: 300,
      },
      [theme.breakpoints.down('md')]: {
        width: 250,
      },
      [theme.breakpoints.down('sm')]: {
        width: 200,
      }
    },
    '&:nth-child(2)': {
      width: 83,
      whiteSpace: 'normal'
    },
    '&:nth-child(3)': {
      width: 50
    },
    '&:nth-child(4)': {
      width: 80
    },
    '&:nth-child(5)': {
      width: 85
    },
    '&:nth-child(12)': {
      width: 100
    },
    whiteSpace: 'nowrap'
  },
  buttonCancel: {
    color: theme.palette.secondary.main,
  },
  dialogTitle: {
    background: ERROR_BACKGROUND,
  },
  messageContent: {
    paddingTop: theme.spacing(2),
  }
});

const AssetsSelectionModal = withStyles(AssetsSelectionModalStyles)((props) => {
  const {
    classes,
    open,
    handleClose,
    dataService,
    instrumentsHandler,
    depot,
    dispatch,
    vlPlanEnabled,
    handleSaveClick,
    emptyTableMsg,
  } = props;

  const [loading, setLoading] = React.useState(false);
  const [activeSource, setActiveSource] = React.useState(null);
  const [activeSourceItem, setActiveSourceItem] = React.useState(null);
  const [assets, setAssets] = React.useState([]);
  const [assetsSearch, handleSearchActivate, addExtraFilters] = useAssetSelectionSearch({custodian: depot.bankCompanyId}, dispatch);
  const [useExpertFilter, setUseExpertFilter] = React.useState(false);

  const availableInstrumentsSources = React.useMemo(() => {

    if (!depot || !depot.selected_contract_type) {
      return []
    }

    return getContractTypeConfiguration(
      depot.selected_contract_type,
      dataService.isOpenOnly ? 'open_only_instrument_sources' : 'instrument_sources',
      [])

  }, []);

  const findAssetIndex = (assets, asset) => {
    return _.findIndex(assets, a => getAssetInternalId(a) === getAssetInternalId(asset));
  };

  const handleAddAssetClick = (asset) => {
    handleAddInstrumentsFilters([asset], true);
  };

  const handleAddInstrumentsFilters = (instruments, unselectIfExists=false) => {
    let assetsCopy = [...assets];

    (instruments || []).forEach(instrument => {
      const idx = findAssetIndex(assetsCopy, instrument);
      if (idx === -1) {
        assetsCopy.push({...instrument, selected: true});
      } else if(unselectIfExists) {
        assetsCopy[idx].selected = !assetsCopy[idx].selected;
      }
    });

    setAssets(assetsCopy);
    setUseExpertFilter(false);
    setActiveSourceItem(null);
    setActiveSource(null);
  };

  const handleFiltersExtendedButtonClick = () => setUseExpertFilter(true);

  const onSelectAll = () => {
    const selected = selectedAssets.length !== assets.length;
    setAssets(assets.map(a => ({...a, selected: selected})))
  };

  const handleSourceClick = (source) => () => setActiveSource(source);

  const handleSourceBackClick = () => {
    if(activeSourceItem){
      setActiveSourceItem(null);
    } else {
      setActiveSource(null);
    }
  };

  const handleNextClick = async () => {
    setLoading(true);
    await handleSaveClick(undefined, selectedAssets);
    handleClose();
    setLoading(false);
    setAssets([]);
  };

  const selectedAssets = _.filter(assets, 'selected');
  const hasSelectedAssets = !_.isEmpty(selectedAssets);

  const cancelSelection = useCancelSelection({hasSelectedAssets, handleClose, handleNextClick});

  const instrumentsSources = React.useMemo(() => {
    return [
      {
        text: "Favoritenlisten",
        variant: "outlined",
        onButtonClick: handleSourceClick("FavouriteList"),
        disabled: !availableInstrumentsSources.includes(INSTRUMENT_SOURCE_TYPE.FAVOURITE_LIST)
      }, {
        text: "Musterdepot",
        variant: "outlined",
        onButtonClick: handleSourceClick("MusterDepot"),
        disabled: !availableInstrumentsSources.includes(INSTRUMENT_SOURCE_TYPE.MUSTER_DEPOT) || vlPlanEnabled
      }
    ];
  }, [availableInstrumentsSources]);

  const instrumentsSearchDisabled = React.useMemo(() => {
    return !availableInstrumentsSources.includes(INSTRUMENT_SOURCE_TYPE.SEARCH)
  }, [availableInstrumentsSources]);

  return (
    <>
      {!!activeSource && (
        <AssetsSelectionSourceComponent
          dataService={dataService}
          activeSource={activeSource}
          handleAddInstruments={handleAddInstrumentsFilters}
          instrumentsHandler={instrumentsHandler}
          activeSourceItem={activeSourceItem}
          setActiveSourceItem={setActiveSourceItem}
          dispatch={dispatch}
          handleBackClick={handleSourceBackClick}
        />
      )}
      <BaseDialog
        title={'Investment hinzufügen'}
        open={open}
        handleClose={cancelSelection}
        disableBackdropClick
        classes={!!activeSource ? {root: classes.rootInvisible} : undefined}
        actions={
          <Grid container spacing={2} justify={"flex-end"}>
            <Grid item>
              <PrimaryButton
                variant={'outlined'}
                text={'Abbrechen'}
                onButtonClick={cancelSelection}
                disabled={loading}
              />
            </Grid>
            {(!activeSource || activeSourceItem) && (
              <Grid item>
                <PrimaryButton
                  text={'Speichern & weiter'}
                  onButtonClick={handleNextClick}
                  disabled={loading || !hasSelectedAssets}
                />
              </Grid>
            )}
          </Grid>
        }
      >
        <AssetsSelectionPage
          instrumentsHandler={instrumentsHandler}
          assetsSearch={assetsSearch}
          handleSearchActivate={handleSearchActivate}
          assets={assets}
          instrumentsSources={instrumentsSources}
          handleAddAssetClick={handleAddAssetClick}
          instrumentsSearchDisabled={instrumentsSearchDisabled}
          handleFiltersExtendedButtonClick={handleFiltersExtendedButtonClick}
        >
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12} className={classes.header}>Produktauswahl</Grid>
              <Grid item xs={12}>
                <DashboardTable
                  structure={favoriteListDetailsTableStructure}
                  dataSource={assets}
                  tableClasses={classes}
                  expanded
                  withFooter={false}
                  emptyDataMessage={emptyTableMsg}
                  options={{
                    totalInstrumentsCount: assets.length,
                    onInstrumentSelect: handleAddAssetClick,
                    onAllSelect: assets.length ? onSelectAll : undefined,
                    selected: selectedAssets,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </AssetsSelectionPage>
      </BaseDialog>
      <BaseDialog open={useExpertFilter}>
        <Link
          title="Schließen"
          icon={<i className="fa fa-chevron-left" aria-hidden="true" />}
          underline
          onClick={() => setUseExpertFilter(false)}
        />
        <ModelportfoliosFilters
          onAddInstruments={handleAddInstrumentsFilters}
          instrumentsHandler={instrumentsHandler}
          addExtraFilters={addExtraFilters}
          useButtons
          predefinedFilter={{cCustodian: [{label: depot.depot, id: depot.bankCompanyId, value: depot.bankCompanyId}]}}
        />
      </BaseDialog>
    </>
  )
});

class AssetsSelection extends ModelPortfolioBase {

  constructor(props) {

    super(props);
    const dataService = props.dataService;
    const bankCompanyId = dataService.bankCompanyId;

    const rotationOptions = getBankData(dataService.banksData, bankCompanyId, 'savings_plan_periodic_plans');
    const fromDateOptions = getBankData(dataService.banksData, bankCompanyId, 'savings_plan_execution_dates');

    this.state = {
      ...this.state,

      bankCompanyId: bankCompanyId,
      confirmRiskModalOpen: false,
      confirmRiskModalActiveAsset: undefined,
      portfolioBuilderOpen: false,
      isPIProcess: dataService.isPIProcess(),
      isMPProcess: dataService.isMPProcess(),
      isPBProcess: dataService._isPortfolioBuilderEnabled(),
      bookingDatePossible: getBankData(dataService.banksData || [], bankCompanyId, 'onboarding_booking_date_possible'),
      productSelectionOpen: false,
      instrumentsHandler: this.props.instrumentsHandler || new CustodianAndRiskProfileInstrumentsHandler(bankCompanyId, undefined, dataService._target_market, undefined, this.props.vlPlanEnabled),
      defaultPlan: {
        rotation: _.get(rotationOptions, '0'),
        from_date: nextAvailableFromDate(fromDateOptions)
      }
    }
  }

  componentDidMount() {
    super.componentDidMount();

    // auto open PB in case it was not opened and there's no instruments stored yet
    if(this.state.isPBProcess && !this.props.dataService.portfolioBuilderAutoOpened && _.isEmpty(this.getGroupedInstruments())){
      this.props.dataService.portfolioBuilderAutoOpened = true;
      this.openPortfolioBuilder();
    }
  }

  // customer memoization
  lastInstruments = null;
  lastGrouped = null;

  openPortfolioBuilder = () =>  {
    this.setState({portfolioBuilderOpen: true});
    GoogleAnalytics.trackPortfolioBuilderOpen();
  };

  getGroupedInstruments() {
    if (this.props.instruments !== this.lastInstruments) {
      this.lastInstruments = this.props.instruments;
      this.lastGrouped = this.groupInstruments(this.props.instruments || []);
    }
    return this.lastGrouped;
  }

  groupInstruments(instruments) {
    let instrumentsGrouped = {};
    instruments.forEach(i => {
      const data = {...i};

      if(i.savingsPlan) {
        data.savingsPlanAmount = i.amount;
        delete data.amount;
      }
      instrumentsGrouped[i.isin] = {...instrumentsGrouped[i.isin], ...data}
    });

    return Object.values(instrumentsGrouped);
  }

  _initWeightAmountForAsset = (asset, portfolioAmount) => {
    const custodianData = instrCustodianData(asset, this.state.bankCompanyId);
    const hasAmount = !_.isNaN(+asset.amount);
    const hasPlanAmount = !_.isNaN(+asset.savingsPlanAmount);

    if(hasAmount || hasPlanAmount){
      asset.amount = (hasAmount && custodianData.c_single_payment_possible) ? +asset.amount : undefined;
      asset.savingsPlanAmount = (hasPlanAmount && custodianData.c_savings_plan_possible) ? +asset.savingsPlanAmount : undefined;
      asset.weight = (hasAmount && portfolioAmount !== 0) ? (asset.amount / portfolioAmount) * 100 : 0;
      if(!this.state.bookingDatePossible){
        asset.deposit_from_type = undefined;
        asset.deposit_from_date = undefined;
      }
    } else if(+asset.weight && custodianData.c_single_payment_possible){
      asset.weight = +asset.weight;
      asset.amount = portfolioAmount * (asset.weight / 100) || undefined;
      asset.savingsPlanAmount = undefined;
    } else {
      asset.weight = 0;
      asset.amount = undefined;
      asset.savingsPlanAmount = undefined;
    }

    if(!asset.is_fund){
      initEinzeltitelSettings(asset, this.props.dataService.bank && this.props.dataService.bank.stock_exchange_options || [])
    }
  };

  removeAssetClick = (asset) => {
    if(asset.isInvestmentStrategy || asset.is_modelportfolio){
      this.props.onDeleteModelPortfolioClick(asset)
    } else {
      let selectedAssetsCopy = [...this.getGroupedInstruments()];

      const idx = this.findAssetIndex(selectedAssetsCopy, asset);
      if (idx !== -1) {
        selectedAssetsCopy.splice(idx, 1);
        this.setSelectedAssets(selectedAssetsCopy)  // to re-calculate weights
      }
    }
  };

  setSelectedAssets = (instruments, cleanSource=true) => {
    let items = [...instruments];
    const totalAmount = (this.props.instrumentsSource ? this.props.instrumentsSource.amount : _.sumBy(items, (a) => a.amount || 0)) || 0;
    items.forEach(a => this._initWeightAmountForAsset(a, totalAmount));
    this.handleSelectedAssetsChange(items, cleanSource)
  };

  handleSaveClick = async (sourceItem, selectedInstruments) => {
    // Use assets directly from sourceItem in case it provided from details page
    let newItems = [...selectedInstruments],
        existingInstruments = this.getGroupedInstruments(),
        msg = "Die Instrumente wurde der Produktauswahl hinzugefügt.";

    const isInvestmentStrategy = _.get(sourceItem, 'isInvestmentStrategy');

    // wait for user to confirm risk score or stop process. Note: method set risk flags for InvestmentStrategy so we should pass sourceItem iself
    if (!await this.props.confirmChange(!isInvestmentStrategy ? newItems : [sourceItem])) {
      return false
    }
    // if there were answers - confirm that they will be overwritten or stop process
    if(!!this.props.instrumentsSource) {
      existingInstruments = []; // override model portfolio instruments
    }
    // if active source is FavouriteList or MusterDepot and there are existingInstruments -> add source instruments to existing
    if(!sourceItem){
      if(!_.isEmpty(existingInstruments)){
        // add new items to existing
        newItems = _.uniqBy([...existingInstruments, ...newItems], 'isin');
      }

      this.setSelectedAssets(newItems);
    } else {
      msg = isInvestmentStrategy
        ? "Die Vermögensverwaltung wurde der Produktauswahl hinzugefügt."
        : "Das Modellportfolio wurde der Produktauswahl hinzugefügt.";

      this.handleSelectedAssetsChange(newItems);
      this.props.onInstrumentsSourceAnswerChange({
        ...sourceItem,
        sourceType: isInvestmentStrategy
          ? INSTRUMENT_SOURCE_TYPE.INVESTMENT_STRATEGY
          : INSTRUMENT_SOURCE_TYPE.MODEL_PORTFOLIO
      })
    }

    // set proper snackbar
    this.props.dispatch(displaySuccessSnackBar(msg));
  };

  handleSelectedAssetsChange = (selectedAssets, cleanSource=true) => {
    const splittedAssets = [];

    selectedAssets.forEach(i => {
      if(!i.amount && !i.savingsPlanAmount){
        splittedAssets.push({
          ...i,
          savingsPlan: false
        })
      } else {
        if(i.amount){
          splittedAssets.push({
            ...i,
            savingsPlan: false
          })
        }
        if(i.savingsPlanAmount){
          splittedAssets.push({
            ...i,
            amount: i.savingsPlanAmount,
            savingsPlan: true
          })
        }
      }
    });

    this.props.onAssetsUpdate(splittedAssets, cleanSource);
  };

  handleConfirmRiskModalClose = () => {
    this.setState({
      ...this.state,
      confirmRiskModalOpen: false,
      confirmRiskModalActiveAsset: undefined
    })
  }

  handleSelectAsset = (asset) => {
    this.setState({
      ...this.state,
      confirmRiskModalOpen: true,
      confirmRiskModalActiveAsset: asset
    })
  };

  validateAmount = (item, value, field) => {
    field = field || 'amount';
    const bankPaymentPlanMinAmountField = this.props.vlPlanEnabled
      ? 'onboarding_vl_plan_min_amount_payment'
      : 'onboarding_savings_plan_min_amount_payment';
    const instrumentPaymentPlanMinAmountField = this.props.vlPlanEnabled
      ? 'c_min_amount_vl_plan' // NOTE: We assume that vl min amount will be under this field
      : 'c_min_amount_savings_plan';
    const banksMinAmount = parseFloat(_.get(this.props.depot,
      field === 'amount' ? 'onboarding_min_amount_payment' : bankPaymentPlanMinAmountField,
      0));
    let minOrderAmount = instrCustodianData(item, this.state.bankCompanyId)[field === 'amount' ? 'c_min_amount_single_payment' : instrumentPaymentPlanMinAmountField] || 0;
    minOrderAmount = _.max([banksMinAmount, minOrderAmount]);
    value = value || 0;
    if(value < 0){
      return 'Bitte geben Sie einen Wert größer als 0 € ein.';
    } else if(minOrderAmount && value && value < minOrderAmount){
      return `Mindestbetrag: ${minOrderAmount} €`;
    }
    return null;
  };

  render() {
    const {
      classes,
      sharesError,
      instrumentsSource,
      depot,
      vlPlanEnabled,
      einzeltitelEnabled,
      dataService,
    } = this.props;

    const groupedInstruments = this.getGroupedInstruments();
    const showFundsTable = dataService.showFunds();

    const handleInstrumentChange = (instrument, data, cleanSource) => {
      if (!instrument.isInvestmentStrategy && !instrument.is_modelportfolio) {
        handleInstrumentsChange([instrument], data, cleanSource)
      } else {
        const newSourceData = {...instrument, ...data};
        this.handleSelectedAssetsChange(initSourceAssets(newSourceData, groupedInstruments), false);
        this.props.onInstrumentsSourceAnswerChange(newSourceData);
      }
    };

    const handleInstrumentsChange = (instruments, data, cleanSource) => {
      let items = [...groupedInstruments];
      let updated = false;

      instruments.forEach(instrument => {
        const idx = this.findAssetIndex(items, instrument);

        if(idx !== -1) {
          items[idx] = {...items[idx], dirty: true, ...data};
          updated = true;
        }
      });

      if(updated){
        this.setSelectedAssets(items, cleanSource)
      }
    };

    const handleAmountChange = (item, value) => {
      const data = {
        amount: value,
        error: {...item.error, amount: this.validateAmount(item, value)}
      };

      if(_.isNil(value)){
        data.weight = 0; // reset weight if value was cleaned
      }

      handleInstrumentChange(item, data);
    };

    const handleSavingsPlanChange = (item, value) => {
      handleInstrumentChange(item, {
        savingsPlanAmount: value,
        savingPlanData: item.savingPlanData || this.state.defaultPlan,
        error: {...item.error, savingsPlanAmount: this.validateAmount(item, value, 'savingsPlanAmount')}
      });
    };

    const handleSavingsPlanSettingChange = (item, value, populate) => {
      const data = {savingPlanData: value};
      if (!item.isInvestmentStrategy && !item.is_modelportfolio) {
        const items = populate ? groupedInstruments : [item];
        handleInstrumentsChange(items.filter(i => i.savingsPlanAmount), data)
      } else {
        this.props.onInstrumentsSourceAnswerChange({...item, ...data});
      }
    };

    const handleBookingDateChange = (item, value, populate) => {
      if (!item.isInvestmentStrategy && !item.is_modelportfolio) {
        const items = populate ? groupedInstruments : [item];
        handleInstrumentsChange(items.filter(i => i.amount), value)
      } else {
        this.props.onInstrumentsSourceAnswerChange({...item, ...value});
      }
    };

    const handleConfirmRiskModalSave = (item, value) => {
      if (!item.isInvestmentStrategy) {
        handleInstrumentChange(item, {
          risk_score_explanation: value,
          error: {...item.error, risk_score_explanation: undefined}
        }, false)
      } else {
        const instrumentSourceCopy = {...item};
        _.set(instrumentSourceCopy, 'error.risk_score_explanation', undefined);
        _.set(instrumentSourceCopy, 'risk_score_explanation', value);
        this.props.onInstrumentsSourceAnswerChange(instrumentSourceCopy);
      }
      this.setState({
        confirmRiskModalOpen: false,
        confirmRiskModalActiveAsset: undefined
      })
    };

    const expandSummaryLineChange = (item, expanded) => {
      this.props.onInstrumentsSourceAnswerChange({...item, showAssets: expanded});
    };

    const onAddAssetClick = () => this.setState({productSelectionOpen: true});

    const isAnlageberatung = dataService.serviceConcept == SERVICE_CONCEPTS.Anlageberatung;
    const isMPorPI = this.state.isMPProcess || this.state.isPIProcess;

    const closePortfolioBuilder = () => this.setState({portfolioBuilderOpen: false});

    const setPortfolioBuilderRecommendations = (assets) => {
      // in case assets were set from PB we need to validate amounts
      assets = assets.map((asset) => {
        asset.error = {...asset.error, amount: this.validateAmount(asset, asset.amount)};

        return asset;
      });

      this.handleSaveClick(undefined, assets).finally(closePortfolioBuilder);

      GoogleAnalytics.trackPortfolioBuilderResults();
    };

    const renderTables = () => {

      const emptyTableMsg = <EmptyTableMessage isMPorPI={isMPorPI} />
      const clientSRRI = isAnlageberatung && dataService._srri;
      const isOpenOnly = dataService.isOpenOnly;
      const hasDefaultInstrument = isOpenOnly && dataService.getBankConfig(depot)['onboarding_open_only_default_instrument']
      const addAssetHandler = hasDefaultInstrument ? undefined : onAddAssetClick;

      let mainTable, internalInstruments = [], mainInstruments = [];
      [internalInstruments, mainInstruments] = splitEinzeltitelTradingInstruments(groupedInstruments, {}, internalInstruments, mainInstruments);

      if (showFundsTable) {
        let mainTableSource = mainInstruments || [];

        const useMPStructure = isMPorPI || !!instrumentsSource;

        if(!!instrumentsSource){
          const summaryLine = {
            showAssets: !instrumentsSource.isInvestmentStrategy,
            weight: 100,
            ...instrumentsSource,
            tableProps: {summaryLine: true},
          };

          mainTableSource = summaryLine.showAssets ? [summaryLine, ...mainTableSource] : [summaryLine];
        }

        mainTable = (
          <DashboardTable
            structure={useMPStructure ? newDesignTableStructureMP : (vlPlanEnabled ? newDesignTableStructureVL : newDesignTableStructureWithSavingsPlan)}
            dataSource={mainTableSource}
            expanded={true}
            loadingIndicator={false}
            tableClasses={classes}
            withFooter={true}
            withInputs={true}
            withHeader={true}
            emptyDataMessage={emptyTableMsg}
            dataSourceKeyField={'isin'}
            options={{
              bankCompanyId: this.state.bankCompanyId,
              clientSRRI: clientSRRI,
              readOnly: !!instrumentsSource,
              riskOnSummary: !!instrumentsSource && instrumentsSource.isInvestmentStrategy,
              handleAmountChange: handleAmountChange,
              handleSavingsPlanChange: handleSavingsPlanChange,
              handleSavingsPlanSettingChange: handleSavingsPlanSettingChange,
              expandSummaryLineChange: expandSummaryLineChange,
              hasMultipleSavingsPlans: !useMPStructure && mainTableSource.filter(i => i.savingsPlanAmount).length > 1,
              hasMultipleOrders: !useMPStructure && mainTableSource.filter(i => i.amount).length > 1,
              handleBookingDateChange: this.state.bookingDatePossible ? handleBookingDateChange : undefined,
              onRemoveAssetClick: this.removeAssetClick,
              isOpenOnly: isOpenOnly,
              isNewDesign: true,
              onAddAssetClick: addAssetHandler,
              hideAcceptanceCriteriasUnderName: true,
              banksData: dataService.banksData,
              ...TotalPortfolioAmount(mainInstruments)
            }}
          />
        )
      }

      return (
        <>
          <Grid item xs={12}>
            {mainTable}
          </Grid>
          {einzeltitelEnabled && (
            <>
              <Grid item xs={12} className={classes.tableTitle}>Einzeltitel/Aktien</Grid>
              <Grid item xs={12}>
                <InfoCard uid={"einzeltitel_info_text"} info_text={USE_CUSTODIAN_ONLINE_PORTAL_INFO_TEXT} isNewDesign />
              </Grid>
              <Grid item xs={12}>
                <EinzeltitlelTable
                  handleInstrumentChange={handleInstrumentChange}
                  handleInstrumentsChange={handleInstrumentsChange}
                  internalInstruments={internalInstruments}
                  clientSRRI={clientSRRI}
                  error={sharesError}
                  emptyTableMsg={emptyTableMsg}
                  bankCompanyId={this.state.bankCompanyId}
                  readOnly={!!instrumentsSource}
                  stockExchangeOptions={dataService.bank && dataService.bank.stock_exchange_options}
                  orderTypeOptions={dataService.bank && dataService.bank.einzeltitel_order_type_buy}
                  handleRemove={this.removeAssetClick}
                  isOpenOnly={isOpenOnly}
                  onAddAssetClick={addAssetHandler}
                />
              </Grid>
            </>
          )}
          {isMPorPI ? (
            <MpPiSelectionModal
              isMPProcess={this.state.isMPProcess}
              open={this.state.productSelectionOpen}
              handleClose={() => this.setState({productSelectionOpen: false})}
              dataService={dataService}
              instrumentsHandler={this.state.instrumentsHandler}
              depot={depot}
              handleSaveClick={this.handleSaveClick}
            />
          ) : (
            <>
              <AssetsSelectionModal
                open={this.state.productSelectionOpen}
                handleClose={() => this.setState({productSelectionOpen: false})}
                dataService={dataService}
                instrumentsHandler={this.state.instrumentsHandler}
                depot={depot}
                handleSaveClick={this.handleSaveClick}
                dispatch={this.props.dispatch}
                vlPlanEnabled={vlPlanEnabled}
                emptyTableMsg={emptyTableMsg}
              />
              {this.state.portfolioBuilderOpen && (
                <PortfolioBuilder
                  setRecommendations={setPortfolioBuilderRecommendations}
                  closeHandler={closePortfolioBuilder}
                  dataService={dataService}
                  caseData={this.props.portfolioBuilderCase || {}}
                  setCaseData={this.props.setPortfolioBuilderCase}
                  instrumentsHandler={this.state.instrumentsHandler}
                />
              )}
            </>
          )}
        </>
      )
    };

    const getTitle = () => {
      if(this.state.isPBProcess){
        return (
          <Grid container justify={"space-between"}>
            <Grid item>Portfolio-Builder</Grid>
            <Grid item>
              <PortfolioBuilderButton
                text={'Portfolio-Builder'}
                onButtonClick={this.openPortfolioBuilder}
                variant={'outlined'}
              />
            </Grid>
          </Grid>
        )
      }

      return this.state.isMPProcess ? 'Modellportfolio' :
        this.state.isPIProcess ? 'Vermögensverwaltung' :
        vlPlanEnabled ? 'Vermögenswirksame Leistungen (VL)' : 'Einzelfonds/Musterdepot';
    };

    return (
      <RiskScoreConfirmationModalContext.Provider
        value={{
          open: this.state.confirmRiskModalOpen,
          activeAsset: this.state.confirmRiskModalActiveAsset,
          onClose: this.handleConfirmRiskModalClose,
          onSave: handleConfirmRiskModalSave,
          onSelectAsset: this.handleSelectAsset,
          singleInvestmentEnabled: this.props.singleInvestmentEnabled || this.state.isPBProcess
        }}
      >
        <Grid container spacing={2}>
          {showFundsTable && (
            <Grid item xs={12} className={classes.tableTitle}>
              {getTitle()}
            </Grid>
          )}
          {isAnlageberatung && !isMPorPI && (
            <Grid item xs={12}>
              Gewichtetes Portfoliorisiko: {toGermanFormat(getAverageSrriValue(groupedInstruments) || 0)}<WarningTooltip title={AVG_PTF_INFO} />
            </Grid>
          )}
          {renderTables()}
        </Grid>
        <RiskScoreConfirmationModal />
      </RiskScoreConfirmationModalContext.Provider>
    )
  }
}

export default connect()(withStyles(styles)(AssetsSelection));